<template>
    <div id="app">
        <template v-if="!error">
            <Header :logo-src="meta.logoUrl" :meta="meta" v-if="!inIframe"/>
            <Main :meta="meta" @app-is-active="applicationIsActive" class="main-container"/>
            <Footer v-if="!inIframe"/>
        </template>

        <div class="m-auto text-center" v-else>
            <div class="alert alert-danger text-center" role="alert">
                {{error}}
            </div>
            <button @click="getMeta" class="btn btn-primary" type="button">
                Wiederholen
            </button>
        </div>
    </div>
</template>

<script>
    import ajax from '@/ajax';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Main from '@/components/Main';
    import parseUrlParams from '@/mixin/parseUrlParams';

    export default {
        name: 'app',
        mixins: [parseUrlParams],
        data() {
            return {
                appIsActive: false,
                meta: {},
                error: null,
            };
        },
        components: {
            Header,
            Footer,
            Main,
        },
        computed: {
            inIframe() {
                try {
                    return window.self !== window.top;
                } catch ( e ) {
                    return true;
                }
            },
        },
        methods: {
            async getMeta() {
                this.error = null;
                try {
                    let values = this.parsePageURL();
                    const {data: meta} = await ajax.getMeta( values[0] );
                    this.meta = meta;
                } catch ( e ) {
                    console.error( e );
                    this.error = "Beim Laden der Seite ist ein Problem aufgetreten. " +
                        "Bitte versuchen Sie es später noch einmal";
                }
            },
            applicationIsActive( appIsActive ) {
                this.appIsActive = appIsActive;
            },
        },
        created() {
            this.getMeta();
        },
    }
</script>

<style lang="scss">
    @import "./styles/variables";


    #app {
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        left: 0;
        min-height: 100%;
        overflow-y: scroll;
        position: fixed;
        right: 0;
        top: 0;
        width: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        transition: padding-left 0.75ms ease, padding-right 0.75ms ease;
    }

    @media (max-width: 575.98px) {
        #app {
            padding-left: $main-margin;
            padding-right: $main-margin;
            width: 100%;
        }
    }

    @media (min-width: 576px) and (max-width: 991.98px) {
        #app {
            padding-left: 10%;
            padding-right: 10%;
        }
    }

    @media (min-width: 992px) and (max-width: 1199.98px) {
        #app {
            padding-left: 15%;
            padding-right: 15%;
        }
    }


    // --- portrait ---
    /*
    @media (min-width: 769px) and (orientation: portrait) {
        #app {
            &:before {
                background: $app-background-p960;
            }
        }
    }

    @media (max-width: 768px) and (orientation: portrait) {
        #app {
            &:before {
                background: $app-background-p768;
            }
        }
    }

    @media (max-width: 480px) and (orientation: portrait) {
        #app {
            &:before {
                background: $app-background-p480;
            }
        }
    }

    @media (max-width: 320px) and (orientation: portrait) {
        #app {
            &:before {
                background: $app-background-p320;
            }
        }
    }

    // --- landscape ---
    @media (max-width: 1536px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l1536;
            }
        }
    }

    @media (max-width: 1366px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l1366;
            }
        }
    }

    @media (max-width: 1112px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l1112;
            }
        }
    }

    @media (max-width: 1024px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l1024;
            }
        }
    }

    @media (max-width: 812px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l812;
            }
        }
    }

    @media (max-width: 667px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l667;
            }
        }
    }

    @media (max-width: 480px) and (orientation: landscape) {
        #app {
            &:before {
                background: $app-background-l480;
            }
        }
    }
     */
</style>
